import {
  Box,
  Button,
  Flex,
  IconButton,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Radio,
  Select,
  Text,
  Textarea,
  Tooltip,
  useDisclosure,
} from "@chakra-ui/react";
import { useRef, useState } from "react";
import { BsBoxArrowInLeft } from "react-icons/bs";
import { IoIosAddCircleOutline, IoMdAddCircle } from "react-icons/io";
import { MdOutlineSaveAlt } from "react-icons/md";

export const ModalAddParceiros = (dados) => {
  const OverlayTwo = () => (
    <ModalOverlay
      bg="none"
      backdropFilter="auto"
      backdropInvert="80%"
      backdropBlur="2px"
    />
  );

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [overlay, setOverlay] = useState(<OverlayTwo />);
  const initialRef = useRef();
  const finalRef = useRef();

  let [ClienteEspecial, setClienteEspecial] = useState(null);
  let [CpfCnpj, setCpfCnpj] = useState(null);
  let [NomeParceiro, setNomeParceiro] = useState(null);
  let [RazaoSocial, setRazaoSocial] = useState(null);
  let [InscricaoEstadual, setInscricaoEstadual] = useState(null);
  let [ClassificacaoICMS, setClassificacaoICMS] = useState(null);
  let [TipoPessoa, setTipoPessoa] = useState(null);
  let [Contrato, setContrato] = useState(null);
  let [CEP, setCEP] = useState(null);
  let [NumeroEndereco, setNumeroEndereco] = useState(null);
  let [Complemento, setComplemento] = useState(null);
  let [Email, setEmail] = useState(null);

  return (
    <>
      <Tooltip
        hasArrow
        bg="#03a9f4"
        label="Adicionar Cliente"
        placement="left-start"
      >
        <IconButton
          size="md"
          _hover={{ opacity: 0.8 }}
          bgColor="#03a9f4"
          aria-label="Search database"
          icon={<IoMdAddCircle color="white" size="25px" />}
          boxShadow="none !important"
          onClick={() => {
            setOverlay(<OverlayTwo />);
            onOpen();
          }}
        />
      </Tooltip>
      <Modal
        size={"6xl"}
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
        isCentered
      >
        {overlay}
        <ModalContent>
          <ModalHeader>
            <Flex>
              <Text color="#03a9f4" fontFamily="Akrobat">
                Vendedor:
              </Text>
              <Text ml="1rem" color="gray" fontFamily="Akrobat">
                ...
              </Text>
            </Flex>
          </ModalHeader>
          <ModalCloseButton
            _hover={{ bgColor: "#d6eef7" }}
            boxShadow="none !important"
            color="#03a9f4"
          />
          <ModalBody>
            <Box w="100%">
              <Flex>
                <Text
                  color="#03a9f4"
                  fontFamily="Akrobat ExtraBold"
                  mt="0.2rem"
                >
                  Cód:
                </Text>
                <Input
                  focusBorderColor="#03a9f4"
                  bgColor="#F0F4F5"
                  size="sm"
                  w="20%"
                  ml="0.3rem"
                  disabled={true}
                />
                <Radio
                  colorScheme="twitter"
                  borderColor="#03a9f4"
                  ml="1.5rem"
                  size="lg"
                  onChange={(e) =>
                    setClienteEspecial(e.target.value ? "S" : "N")
                  }
                >
                  Cliente Especial
                </Radio>
                {/* <Flex ml="2rem">
                  <Text
                    color="#03a9f4"
                    fontFamily="Akrobat ExtraBold"
                    mt="0.2rem"
                  >
                    Data do Cadastro:
                  </Text>
                  <Input
                    type="date"
                    focusBorderColor="#03a9f4"
                    bgColor="#F0F4F5"
                    size="sm"
                    w="60%"
                    ml="0.3rem"
                  />
                </Flex> */}
              </Flex>
              <Flex mt="0.5rem">
                <Text
                  color="#03a9f4"
                  fontFamily="Akrobat ExtraBold"
                  mt="0.2rem"
                >
                  CNPJ/CPF:
                </Text>
                <Input
                  focusBorderColor="#03a9f4"
                  bgColor="#F0F4F5"
                  size="sm"
                  w="16.7%"
                  ml="0.3rem"
                  onChange={(e) => setCpfCnpj(e.target.value)}
                />
              </Flex>
              <Flex mt="1rem">
                <Button
                  w="220px"
                  boxShadow="none !important"
                  _hover={{ opacity: 0.9 }}
                  size="sm"
                  bgColor="#03a9f4"
                  color="white"
                >
                  CONSULTAR RECEITA FEDERAL
                </Button>
                <Button
                  w="220px"
                  ml="1rem"
                  boxShadow="none !important"
                  _hover={{ opacity: 0.9 }}
                  size="sm"
                  bgColor="#03a9f4"
                  color="white"
                >
                  CONSULTAR SINTEGRA
                </Button>
              </Flex>
            </Box>
            <Flex h="330px">
              <Box w="50%">
                <Flex mt="1rem">
                  <Text
                    color="#03a9f4"
                    fontFamily="Akrobat ExtraBold"
                    mt="0.2rem"
                  >
                    Nome Parceiro:
                  </Text>
                  <Input
                    focusBorderColor="#03a9f4"
                    bgColor="#F0F4F5"
                    size="sm"
                    w="72.8%"
                    ml="0.3rem"
                    onChange={(e) => setNomeParceiro(e.target.value)}
                  />
                </Flex>
                <Flex mt="0.5rem">
                  <Text
                    color="#03a9f4"
                    fontFamily="Akrobat ExtraBold"
                    mt="0.2rem"
                  >
                    Razão Social:
                  </Text>
                  <Input
                    focusBorderColor="#03a9f4"
                    bgColor="#F0F4F5"
                    size="sm"
                    w="75.4%"
                    ml="0.3rem"
                    onChange={(e) => setRazaoSocial(e.target.value)}
                  />
                </Flex>
                <Flex mt="0.5rem">
                  <Text
                    color="#03a9f4"
                    fontFamily="Akrobat ExtraBold"
                    mt="0.2rem"
                  >
                    Insc. Estadual/Identidade:
                  </Text>
                  <Input
                    focusBorderColor="#03a9f4"
                    bgColor="#F0F4F5"
                    size="sm"
                    w="61%"
                    ml="0.3rem"
                    onChange={(e) => setInscricaoEstadual(e.target.value)}
                  />
                </Flex>
                <Flex mt="0.5rem">
                  <Text
                    color="#03a9f4"
                    mt="0.2rem"
                    fontFamily="Akrobat ExtraBold"
                  >
                    Classificação ICMS:
                  </Text>
                  <Select
                    ml="0.3rem"
                    focusBorderColor="#03a9f4"
                    iconColor="#03a9f4"
                    bgColor="#F0F4F5"
                    size="sm"
                    w="28%"
                    onChange={(e) =>
                      setClassificacaoICMS(
                        e.target.options[e.target.options.selectedIndex].value
                      )
                    }
                  >
                    <option value={"X"}>Contribuinte</option>
                    <option value={"C"}>Não Contribuinte</option>
                  </Select>
                </Flex>
                <Flex mt="0.5rem">
                  <Text
                    color="#03a9f4"
                    fontFamily="Akrobat ExtraBold"
                    mt="0.2rem"
                  >
                    Tipo de Pessoa:
                  </Text>
                  <Select
                    ml="0.3rem"
                    focusBorderColor="#03a9f4"
                    iconColor="#03a9f4"
                    bgColor="#F0F4F5"
                    size="sm"
                    w="18%"
                    onChange={(e) =>
                      setTipoPessoa(
                        e.target.options[e.target.options.selectedIndex].value
                      )
                    }
                  >
                    <option value={"F"}>Física</option>
                    <option value={"J"}>Jurídica</option>
                  </Select>
                </Flex>
                <Flex mt="0.5rem">
                  <Text
                    color="#03a9f4"
                    fontFamily="Akrobat ExtraBold"
                    mt="0.2rem"
                  >
                    Contrato:
                  </Text>
                  <Input
                    focusBorderColor="#03a9f4"
                    bgColor="#F0F4F5"
                    size="sm"
                    w="79%"
                    ml="0.3rem"
                    onChange={(e) => setContrato(e.target.value)}
                  />
                </Flex>
                {/* <Flex mt="0.5rem">
                  <Text
                    color="#03a9f4"
                    fontFamily="Akrobat ExtraBold"
                    mt="0.2rem"
                  >
                    Data Alteração Plataforma:
                  </Text>
                  <Input
                    type="date"
                    focusBorderColor="#03a9f4"
                    bgColor="#F0F4F5"
                    size="sm"
                    w="30%"
                    ml="0.3rem"
                  />
                </Flex> */}
              </Box>
              <Box w="50%">
                <Flex mt="1rem">
                  <Text
                    color="#03a9f4"
                    fontFamily="Akrobat ExtraBold"
                    mt="0.2rem"
                  >
                    Endereço:
                  </Text>
                  <Input
                    focusBorderColor="#03a9f4"
                    w="77%"
                    type="text"
                    bgColor="#F0F4F5"
                    size="sm"
                    ml="0.3rem"
                  />
                </Flex>
                <Flex mt="0.5rem">
                  <Text
                    color="#03a9f4"
                    fontFamily="Akrobat ExtraBold"
                    mt="0.2rem"
                  >
                    CEP:
                  </Text>
                  <Input
                    focusBorderColor="#03a9f4"
                    w="20%"
                    type="text"
                    bgColor="#F0F4F5"
                    size="sm"
                    ml="0.3rem"
                    onChange={(e) => setCEP(e.target.value)}
                  />
                  <Text
                    ml="1rem"
                    color="#03a9f4"
                    fontFamily="Akrobat ExtraBold"
                    mt="0.2rem"
                  >
                    Número:
                  </Text>
                  <Input
                    focusBorderColor="#03a9f4"
                    w="13%"
                    type="text"
                    bgColor="#F0F4F5"
                    size="sm"
                    ml="0.3rem"
                    onChange={(e) => setNumeroEndereco(e.target.value)}
                  />
                </Flex>
                <Flex mt="0.5rem">
                  <Text
                    color="#03a9f4"
                    fontFamily="Akrobat ExtraBold"
                    mt="0.2rem"
                  >
                    Complemento:
                  </Text>
                  <Input
                    focusBorderColor="#03a9f4"
                    w="71.9%"
                    type="text"
                    bgColor="#F0F4F5"
                    size="sm"
                    ml="0.3rem"
                    onChange={(e) => setComplemento(e.target.value)}
                  />
                </Flex>
                <Flex mt="0.5rem">
                  <Text
                    color="#03a9f4"
                    fontFamily="Akrobat ExtraBold"
                    mt="0.2rem"
                  >
                    Bairro:
                  </Text>
                  <Input
                    focusBorderColor="#03a9f4"
                    w="80.3%"
                    type="text"
                    bgColor="#F0F4F5"
                    size="sm"
                    ml="0.3rem"
                  />
                </Flex>
                <Flex mt="0.5rem">
                  <Text
                    color="#03a9f4"
                    fontFamily="Akrobat ExtraBold"
                    mt="0.2rem"
                  >
                    Cidade:
                  </Text>
                  <Input
                    focusBorderColor="#03a9f4"
                    w="30%"
                    type="text"
                    bgColor="#F0F4F5"
                    size="sm"
                    ml="0.3rem"
                  />
                  <Text
                    ml="1rem"
                    color="#03a9f4"
                    fontFamily="Akrobat ExtraBold"
                    mt="0.2rem"
                  >
                    Estado:
                  </Text>
                  <Input
                    focusBorderColor="#03a9f4"
                    w="30%"
                    type="text"
                    bgColor="#F0F4F5"
                    size="sm"
                    ml="0.3rem"
                  />
                </Flex>

                <Flex mt="0.5rem">
                  <Text
                    color="#03a9f4"
                    fontFamily="Akrobat ExtraBold"
                    mt="0.2rem"
                  >
                    E-mail p/ envio NF-e/NFS-e/CT-e:
                  </Text>
                  <Textarea
                    w="43.5%"
                    focusBorderColor="#03a9f4"
                    resize="none"
                    type="text"
                    bgColor="#F0F4F5"
                    size="sm"
                    ml="0.3rem"
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <Flex flexDirection="column">
                    <Button
                      size="sm"
                      bgColor="#03a9f4"
                      leftIcon={
                        <IoIosAddCircleOutline color="white" size="25px" />
                      }
                      ml="0.5rem"
                      color="white"
                      _hover={{ opacity: 0.8 }}
                      boxShadow="none !important"
                    >
                      E-mail
                    </Button>
                    <Button
                      mt="1rem"
                      size="sm"
                      bgColor="#ff9045"
                      leftIcon={<MdOutlineSaveAlt color="white" size="25px" />}
                      ml="0.5rem"
                      color="white"
                      _hover={{ opacity: 0.9 }}
                      boxShadow="none !important"
                      onClick={() =>
                        dados.insertNewClient(
                          {
                            ClienteEspecial: ClienteEspecial,
                            CpfCnpj: CpfCnpj,
                            NomeParceiro: NomeParceiro,
                            RazaoSocial: RazaoSocial,
                            InscricaoEstadual: InscricaoEstadual,
                            ClassificacaoICMS: ClassificacaoICMS,
                            TipoPessoa: TipoPessoa,
                            Contrato: Contrato,
                            CEP: CEP,
                            NumeroEndereco: NumeroEndereco,
                            Complento: Complemento,
                            Email: Email,
                          },
                          onClose
                        )
                      }
                    >
                      Salvar
                    </Button>
                  </Flex>
                </Flex>
              </Box>
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button
              leftIcon={<BsBoxArrowInLeft size="25px" />}
              bgColor="#03a9f4"
              _hover={{ backgroundColor: "#03a9f4", opacity: "0.9" }}
              color="white"
              onClick={onClose}
            >
              Fechar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
